<div class="flex items-start">
  <app-card class="flex-grow me-4">
    <ng-container header>
      <h3 class="mb-0">
        Kundedata
        @if (customer().customer; as customer) {
          <span class="customer-id">#{{ customer?.vismaId }}</span>
        }
      </h3>
      <button mat-flat-button (click)="openOrderHistory()">Vis købshistorik</button>
    </ng-container>
    @if (customer().customer; as customer) {
      <div class="relative">
        <p class="customer-type">
          {{ customer?.accountType === '1' ? 'Privat' : 'Erhverv' }}
        </p>
        <div class="customer-information">
          <div>
            <p>Navn:</p>
            <p>E-mail:</p>
            <p>Telefonnr.:</p>
          </div>
          <div>
            <p>{{ customer?.fullName }}</p>
            <p>{{ customer?.emailForOrderConfirmation }}</p>
            <p>{{ twoSpaceNumber(customer?.phoneNumber) }}</p>
          </div>
        </div>
        @if (customer?.defaultBillingAddress; as address) {
          <h4>Adresseoplysninger</h4>
          <div class="customer-information">
            <div>
              <p>Addresse:</p>
              <p>By:</p>
            </div>
            <div>
              <p>{{ address?.address }}</p>
              <p>{{ address?.addressZip }} {{ address?.addressCity }} {{ address?.countryCode }}</p>
            </div>
          </div>
        }
        @if (customer.accountType === '2') {
          <h4>Firmaoplysninger</h4>
          <div class="customer-information">
            <div>
              <p>Firma:</p>
              @if (customer?.cvr) {
                <p>CVR:</p>
              }
              @if (customer?.ean) {
                <p>EAN:</p>
              }
            </div>
            <div>
              <p>{{ customer?.companyName }}</p>
              @if (customer?.cvr) {
                <p>{{ customer?.cvr }}</p>
              }
              @if (customer?.ean) {
                <p>{{ customer?.ean }}</p>
              }
            </div>
          </div>
        }
      </div>
      <div class="flex mt-4">
        <button mat-flat-button (click)="openCustomerForm()" class="flex-1 btn-grey">Rediger kunde</button>
        @if (!customer?.hasPassword) {
          <button mat-flat-button (click)="sendFinishSignupSmsReminder()" class="flex-1 btn-grey ms-3">
            @if (loadingSendFinishSignupSmsReminder()) {
              <mat-spinner diameter="20"/>
            } @else {
              Send oprettelses-SMS
            }
          </button>
        }
        @if (customerOnJournal()) {
          <button mat-flat-button color="warn" (click)="removeCustomerFromJournal()" class="ms-3">
            @if (loadingRemoveCustomerFromJournal()) {
              <mat-spinner diameter="20"/>
            } @else {
              Fjern fra bon
            }
          </button>
        } @else {
          <button mat-flat-button (click)="addCustomerToJournal()" class="ms-3">
            @if (loadingAddCustomerToJournal()) {
              <mat-spinner diameter="20" class="spinner-white"/>
            } @else {
              Tilføj til bon
            }
          </button>
        }
      </div>
    } @else {
      <p>Der er ikke valgt en kunde</p>
    }
  </app-card>
  <app-customer-newsletter-form/>
</div>
